import React from 'react';

/**
 * Small pill worn next to simulated metrics so it's visually obvious the
 * numbers aren't on-chain data. Two visual variants: `lime` (high emphasis)
 * and `mint` (quieter, for repeated use in a card grid).
 */
export default function DemoBadge({ label = 'DEMO DATA', tone = 'mint', className = '' }) {
  const styles =
    tone === 'lime'
      ? 'bg-palm-lime/15 text-palm-lime border-palm-lime/40'
      : 'bg-white/5 text-palm-mint/80 border-palm-mint/25';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-[3px] text-[9px] font-bold tracking-[0.22em] uppercase ${styles} ${className}`}
      data-testid="demo-data-badge"
    >
      <span className="w-1 h-1 rounded-full bg-current" />
      {label}
    </span>
  );
}

/**
 * Single-line italic disclaimer used below metric groups and in the footer.
 */
export function DemoDisclaimer({ className = '' }) {
  return (
    <p
      className={`text-[11px] italic text-palm-mint/55 leading-relaxed ${className}`}
      data-testid="demo-disclaimer"
    >
      Metrics shown are simulated for demo purposes. Real on-chain data coming with
      mainnet launch.
    </p>
  );
}
